<div class="h-100 overflow-hidden d-flex flex-column align-items-center justify-content-between">
  <div class="header-bg d-flex align-items-center justify-content-between">
    <busitalia-header />

    <div class="mb-5">
      {{'COMMON.LABEL.NOT_FOUND' | translate}}
    </div>
  </div>

  <div class="p-4">
    <button matButton="filled"
      routerLink="/"
      class="mt-5">
      {{'COMMON.LABEL.BACK_TO_HOME' | translate}}
    </button>
  </div>
</div>